import { EventListItem } from '@unistocks/components/event-list-item/event-list-item';
import { useAssetImage } from '@unistocks/features/assets/hooks/use-asset-image';
import { DashboardEventDto } from '@unistocks/proxy/axios-client';
import { Asset } from '@unistocks/types/asset';
import { ListItemProps } from 'tamagui';

export type AssetEventProps = {
  event: DashboardEventDto;
  asset?: Asset;
} & Omit<ListItemProps, 'title' | 'icon'>;

export const AssetEventListItem: React.FC<AssetEventProps> = ({ event, asset, ...props }) => {
  const image = useAssetImage(asset, { preferAssetImage: true });

  return (
    <EventListItem
      type={event.type}
      subType={event.subType}
      title={asset?.name}
      image={image}
      value={event.value}
      {...props}
    />
  );
};

AssetEventListItem.displayName = 'AssetEventListItem';
